const config = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_FgX7bAYsZ",
    userPoolWebClientId: "9dljjtol8491831a2jboq3ccg",
    identityPoolId: "eu-west-1:bbe733ea-47f4-4ea8-a888-3af11aaa59d0",

  },
};


export const analyticsConfig = {
  AWSPinpoint: {
        // Amazon Pinpoint App Client ID
        appId: '0319c03cb8864b0c9ed2763d4679e29c',
        // Amazon service region
        region: 'eu-west-1',
        mandatorySignIn: false,
  }
}


export default config;